import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import getPage from "~/helpers/getPage"
import News from "~/views/news"

const getInitialProps: GetInitialPropsType = async ({ req, query }) => {
  const apiContext = await getApiContext(
    [
      {
        url: "/press/list",
        query: { items_per_page: 10, page_number: 1, ...query },
        code: "ir-blog",
      },

      { url: "/tags/list" },
      { url: "/formwithcontacts/list", code: "investors-and-shareholders" },
    ],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)
  return { apiContext, crumbs, slug: "ir-blog" }
}

const Page = getPage(getInitialProps, News)

export default Page
